module.exports = __webpack_public_path__ + "static/img/user2.6149f00.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/home/user2.png
// module id = ryfQ
// module chunks = 2